<template>
  <div class="mb-3">
    <div class="col p-0">
      <label
          class="vform-editor-label mt-2">
        {{ $t("vform.sendEmailToAddress") }}
      </label>
      <input
          :id="'chkEmailAddress'"
          v-model="emailAddress"
          :class="['form-text form-text-dark mb-1', $v.emailAddress.$error ? 'form-group--error' : '']"
          type="text"
          @blur="$v.emailAddress.$touch()"
      />
      <div v-if="!$v.emailAddress.required  && $v.emailAddress.$dirty" class="form-error">
        {{ $t('vform.mustFillEmailInput') }}
      </div>
      <div v-if="!$v.emailAddress.email" class="form-error">{{ $t('vform.invalidEmailFormat') }}</div>
    </div>
    <div v-if="emailAddress" class="col p-0">
      <!--todo: add a checkbox which says: "take a screenshot of the vform and send it along" if email address is filled out – use the checkbox-widget used in other places-->
      <checkbox-widget
          :key="forceReRenderKey"
          :initial-value="element.sendScreenshot"
          :label-text="$t('vform.sendScreenshot')"
          :label-for="'sendScreenshot-' + element.uuid"
          @change="setScreenShot"
      />
      <checkbox-widget
          :key="forceReRenderKey"
          :initial-value="element.setUserIdAsReplyTo"
          :label-text="$t('vform.setUserIdAsReplyTo')"
          :label-for="'setUserIdAsReplyTo-' + element.uuid"
          @change="setReplyTo"
      />
      <div v-if="element.setUserIdAsReplyTo" class="form-error p-3">
        {{ $t('vform.LoginBlockEmailAdressHint')}}
      </div>
    </div>
  </div>
</template>

<script>
import {email} from 'vuelidate/lib/validators'
import vFormElementMixin from "@/components/vForm/vFormElementMixin.js";
import CheckboxWidget from "@/components/widgets/editors/Checkbox.vue";
export default {
  name: "VFormCheckout",
  mixins: [vFormElementMixin],
  components: {
    CheckboxWidget,
  },
  props: {
    element: { type: Object, required: true },
  },
  data() {
    return {
      emailAddress: "",
      forceReRenderKey: 0, // used to force re-render of the checkbox widget
    }
  },
  watch: {
    emailAddress() {
      this.$set(this.element, "emailAddress", this.emailAddress);
    },
  },
  mounted() {
    this.prepareElement();
    this.emailAddress = this.element.emailAddress;
  },
  validations: {
    emailAddress: {
      required(value, vm) {
        return vm.emailAddress.trim().length > 0;
      },
      email
    },
  },
  methods: {
    prepareElement() {
      if(this.element.sendScreenshot === undefined) {
        this.$set(this.element, "sendScreenshot", false);
        this.forceReRenderKey++;
      }
    },
    setScreenShot(value) {
      this.$set(this.element, "sendScreenshot", value);
    },
    setReplyTo(value) {
      this.$set(this.element, "setUserIdAsReplyTo", value);
    },
  }
}

</script>